import React from 'react';
import {Link} from "react-router-dom";

import ChevronGrayIcon from 'assets/images/svg/chevron_right_gray.svg'
import { json } from 'helpers/data';
import ServerImage from 'components/server-image/server-image';
import { useTranslation } from 'react-i18next';


interface Props {
    id:number;
    name: string;
    info: string;
    price: Price;
    logo: string;
}

interface Price {
    netPrice: string;
    discrimination: string;
    currencySymbol:string
}

function PickedProduct({name,id, info, price,logo}: Props) {
    const { t } = useTranslation("browse-apps");

    return (
        <div className='product'>
            <div className='product-color'>
            <ServerImage className={"logo"} src={logo} />
            </div>
            <div className='info'>
                <h3>{json(name)}</h3>
                <span>{json(info)}</span>
               {price && (<p>{t("filterBox.from")} <span>{price?.netPrice} {json(price?.currencySymbol)}</span></p>)}
            </div>
            <Link className='link' to={`/app/${id}`}><img src={ChevronGrayIcon} alt="ChevronGray"/> </Link>
        </div>
    );
}

export default PickedProduct;